/* Regista content parity guard.
   Keeps canonical footer contact values identical after theme or app DOM changes. */
(function () {
  'use strict';

  function digits(value) {
    return String(value || '').replace(/[^0-9]/g, '');
  }

  function syncFooter() {
    var footer = document.querySelector('.footer');
    if (!footer) return;

    var site = window.RegistaSite || {};
    var email = String(site.supportEmail || 'support@registafootballshirts.com').trim();
    var whatsapp = digits(site.whatsappNumber || '447429105707');

    var logo = footer.querySelector('.rg-footer-logo');
    var brand = footer.querySelector('.footer__block--brand');
    if (brand) {
      brand.hidden = false;
      brand.removeAttribute('aria-hidden');
      brand.style.setProperty('display', 'flex', 'important');
      brand.style.setProperty('visibility', 'visible', 'important');
      brand.style.setProperty('opacity', '1', 'important');
    }
    if (logo) {
      logo.hidden = false;
      logo.removeAttribute('aria-hidden');
      logo.style.setProperty('display', 'block', 'important');
      logo.style.setProperty('visibility', 'visible', 'important');
      logo.style.setProperty('opacity', '1', 'important');
    }

    var mail = footer.querySelector('.regista-footer-contact__button[href^="mailto:"]');
    if (mail && email) {
      var mailHref = 'mailto:' + email;
      if (mail.getAttribute('href') !== mailHref) mail.setAttribute('href', mailHref);
      var mailText = mail.querySelector('span');
      if (mailText && mailText.textContent !== email) mailText.textContent = email;
    }

    var wa = footer.querySelector('.regista-footer-contact__button[href*="wa.me/"]');
    if (wa && whatsapp) {
      var waHref = 'https://wa.me/' + whatsapp;
      if (wa.getAttribute('href') !== waHref) wa.setAttribute('href', waHref);
      var waText = wa.querySelector('span');
      if (waText && waText.textContent !== 'וואטסאפ') waText.textContent = 'וואטסאפ';
    }
  }

  function init() {
    syncFooter();

    var footerGroup = document.querySelector('.shopify-section-group-footer-group');
    if (!footerGroup || typeof MutationObserver !== 'function') return;

    var observer = new MutationObserver(function () {
      syncFooter();
    });

    observer.observe(footerGroup, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', syncFooter);
})();
